import React from "react";
import { Tab } from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
// import s from "./InnerTabList.module.scss";

const InnerTabList = ({
  selectedTab,
  handleChangeTab,
  tabList,
  noBottomBorder,
  scrollable,
}) => {
  const brandColor = "#36b3be";
  const inActiveTab = "#666";
  const borderColor = "#ddd";

  return (
    <TabContext value={selectedTab}>
      <TabList
        onChange={handleChangeTab}
        TabIndicatorProps={{ style: { backgroundColor: brandColor } }}
        sx={{
          ...(!noBottomBorder && { borderBottom: `1px solid ${borderColor}` }),
        }}
        {...(scrollable && { variant: "scrollable" })}
      >
        {tabList.map((tab) => {
          return (
            <Tab
              key={tab.key}
              label={tab.label}
              value={tab.value}
              sx={{
                "&.MuiTab-textColorPrimary": {
                  color: selectedTab === tab.key ? brandColor : inActiveTab,
                },
                "&.MuiButtonBase-root": { textTransform: "none" },
              }}
            ></Tab>
          );
        })}
      </TabList>
    </TabContext>
  );
};

export default React.memo(InnerTabList);
